import { ModuleWithProviders, NgModule, APP_INITIALIZER } from '@angular/core';
import { LocalStorageConfig, LocalStorageService } from './local-storage.service';

@NgModule({})
export class LocalStorageModule {
  static forRoot(config: LocalStorageConfig): ModuleWithProviders<LocalStorageModule> {
    return {
      ngModule: LocalStorageModule,
      providers: [
        LocalStorageService,
        {
          provide: APP_INITIALIZER,
          multi: true,
          deps: [LocalStorageService],
          useFactory: (svc: LocalStorageService) => () => svc.configure(config),
        },
      ],
    };
  }
}

export { LocalStorageService } from './local-storage.service';
